import React, { useState, useRef, useEffect } from "react";

//Importar custom hook y helpers.
import useRefCalculator from "../../../../../hooks/useRefCalculator";
import useClickOutside from "../../../../../hooks/useClickOutside";
import { getOperatorsToAsing } from "../../../../../helpers/fetch";
import { handleOperatorAsing } from "../../../../../helpers/fetch";
import OperatorToAsingSearcher from "../../../../common/Searcher/OperatorToAsingSearcher";

// MenuAsingOperator: Componenete que renderiza el menú para asignar un chat a un operador.

const Menu = ({ setChatData, containerAsignRef, setOpenMenuChatAsing, idChat, setSessionsChatSelected }) => {
    
    const searchPosition = useRefCalculator(containerAsignRef, 50, -250); //Usar el hook para calcular la posición del menú para asignar.
    const menuRef = useRef(null); // Referencia al contenedor del menú
    const [operadores, setOperadores] = useState([])
    const [operadorFiltered, setOperadorFiltered] = useState([]); //Estado para actualizar las sugerencias de operadores al filtrarse por nombre.
    
    const handleUserAsing = async (idUsuario) => { //Función para asignar un chat a un operador.
            let response = await handleOperatorAsing(idUsuario, idChat)
            console.log("se asignó el chat", response);
            if (response.status === 200) {
                setSessionsChatSelected([]);
                setChatData({});
            } 
    };
    
    useEffect(() => { //Traer la lista de operadores al renderizar el componente.
        const getOperators = async () => {
            try {
                let operators = await getOperatorsToAsing();
                if (operators.status === 200) {
                    setOperadorFiltered(operators.data); 
                    setOperadores(operators.data)
                }
            } catch (error) {
                console.log("error al traer los operadores para asignar", error);
            };
        }
        getOperators();
    }, []);
    
    useClickOutside(menuRef,() => setOpenMenuChatAsing(false));    

    return (
        <>
            {searchPosition.top !== 0 && <div className="container-menu" ref={menuRef} style={{ top: searchPosition.top, left: searchPosition.left }}>

                {/*--------Buscador------------*/}
                <OperatorToAsingSearcher operadores={operadores} setOperadorFiltered={setOperadorFiltered} />

                <div className="container-operador">
                    {operadorFiltered.length>0 ? operadorFiltered.map(operador => (
                        <button className="container-operador__name"
                            key={operador.IdUsuario}
                            onClick={() => { handleUserAsing(operador.IdUsuario); setOpenMenuChatAsing(false) }}
                        >{operador.Nombre}</button>
                    ))
                : <div className="container-operador__failed"><span>No hay operadores</span></div>}
                </div>

            </div>}
        </>
    );
};

export default Menu;